export default {
  DRIVETRAIN: "Motricité",

  DRIVETRAIN_AWD: "All-Wheel Drive",
  DRIVETRAIN_4WD: "Four-Wheel Drive",
  DRIVETRAIN_FWD: "Front-Wheel Drive",
  DRIVETRAIN_RWD: "Rear-Wheel Drive",
};
